<template>
	<div class="sticky-header position-fixed wp_HeaderBackground">
		<div id="topHeader">
			<!--<div-->
			<!--class="mobile-county-modal p-3 modal fade d-md-none"-->
			<!--id="countyselectleModal"-->
			<!--tabindex="-1"-->
			<!--role="dialog"-->
			<!--aria-labelledby="exampleModalLabel"-->
			<!--aria-hidden="false"-->
			<!--v-if="showCountry&&-->
			<!--(getSelectedCountry&&-->
			<!--getSelectedCountry.country_name)"-->
			<!--&gt;-->
			<!--<country-picker @saveChoosedCountry="saveChosenCountry('country-select', $event)"
   >
   </country-picker>-->
			<!--</div>-->
			<!-- <pop-up-modals/> -->
			<div class="container wp_headerContainer" id="topHeaderMainContainer">
				<!-- navigation new -->
				<div class="row display_flexContainer">
					<nav v-if="pageText.headerModules"
						class="navbar navbar-expand-lg navbar-dark bg-blue
                      wp_mainNavTabWidth"
						id="headerNavTab">

						<!-- new design -->
						<!-- mobile navigation toggler -->
						<button
							class="navbar-toggler mobile-sidebar-toggler
                             wp_navBarToggler"
							type="button"
							data-target="#icon-count-btn"
							aria-controls="navbarColor01"
							aria-expanded="false"
							aria-label="Toggle navigation"
							id="headerNavTabBtn1-icon-count-btn"
							@click.prevent="togglesidebar"
							data-test="headerNavTabBtn1">
							<div class="icon icon--ei-navicon icon--s">
								<!-- <img class="icon_cnt" src="@/assets/svg/ei-navicon.svg" alt srcset id="icon-count"> -->
								<svg
									id="headerNavTabSvg1-icon-count"
									class="icon_cnt"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 50 50"
									data-test="headerNavTabSvg1"
								>
									<path d="M10 12h30v4H10z"></path>
									<path d="M10 22h30v4H10z"></path>
									<path d="M10 32h30v4H10z"></path>
								</svg>
							</div>
						</button>

						<!-- mobile navigation toggler // main logo-->
						<component v-for="(widget,wkey) in pageText.headerModules" :key="wkey" :is="widget.variable" :selectedCountry="selected" :data ="widget.widgetProperties"></component>

						<!-- new design -->
							<!-- notificaton cart for tab mobile -->
							<!-- <div style="display:none;" class="wp_containerMobileTabNotification">
								<mobile-header-elements/>
							</div> -->
							<!-- notificaton cart for tab mobile -->

					</nav>
				</div>
				<!-- navigation new -->
			</div>
		</div>
	</div>
</template>

<script>
import PopUpModals from '@/components/shared/modals/PopUpModals'
// import MobileHeaderElements from '@/components/shared/headers/mobile/MobileHeaderElements'
import AuthenticatedUserModels from '@/components/shared/widgets/AuthenticatedUserModels'
// import CountryPicker from '@/components/shared/CountryPicker'
import LogoContainer from '@/components/shared/widgets/LogoContainer'
import CountrySelectorContainer from '@/components/shared/widgets/CountrySelectorContainer'
import HeaderSearch from '@/components/shared/widgets/HeaderSearch'
// import CartDropDown from '@/components/shared/CartDropDown'
import CartButton from '@/components/shared/widgets/CartButton'
import { mapActions, mapGetters } from 'vuex'
import CountryPicker from '../widgets/CountryPicker'

import header from '@/assets/cms_templates_repo/styl.json'

export default {
	name: 'HeaderNavTab',
	beforeMount () {
		this.screenWidth = screen.width

		this.selected = this.getSelectedCountry
	},
	watch: {
		'screen.width': function () {
			this.screenWidth = screen.width
		}
	},
	mounted () {
		$(window)
			.on('load', () => {
				$('#countyselectleModal')
					.modal('hide')
			})
			// this.profilePic = this.getUserData.image_url;
		if ($(window)
			.width() < 991) {
			// $(window)
			//   .on('load', () => {
			//     $('#countyselectleModal')
			//       .modal('show');
			//   });
		}
		// $('#change-contries')
		//   .on('click', () => {
		//
		//     $('#countyselectleModal')
		//       .modal('hide');
		//   });
	},
	data () {
		return {
			pageText: header.components.uielements.headers['header-type-1'].widgetProperties,
			screenWidth: 0,
			selected: '',
			currencyValues: [],
			showCountry: {
				type: Boolean,
				default: true
			}
			// profilePic: '',
		}
	},
	computed: {
		...mapGetters('siteData', [
			'getSelectedCountry',
			'getCountriesWithShipping'
		]),
		...mapGetters('user', [
			'isAuthenticated',
			'getUserData',
			'getProfilePicture'
		]),
		...mapGetters('cart', ['getOrderCart']),
		...mapGetters('cart', ['getCartCount'])
	},
	methods: {
		...mapActions('siteData', [
			'setChosenCountryData',
			'setCountriesWithShipping'
		]),
		// toggleDropDownCountry() {
		//   if (this.selected && this.selected.country_code !== this.getSelectedCountry.country_code) {
		//     this.selected = JSON.parse(JSON.stringify(this.getSelectedCountry));
		//     this.$forceUpdate();
		//   }
		// },

		// changeCountriesStyleToggler() {
		//   $('#countyselectleModal')
		//     .modal('hide');
		//   $('body')
		//     .removeClass('modal-open');
		//   $('.modal-backdrop')
		//     .remove();
		// },
		// toggleDropDown(dropDownId) {
		//   eventService.toggleDropDown(dropDownId);
		// },

		togglesidebar () {
			// eslint-disable-next-line quotes
			document.querySelector('.mobile-side-nav')
				.classList
				.add('shown')
			$('body').addClass('stop-scroll')
			$('#mainApp').addClass('backdrop')
		}
	},
	components: {
		CountryPicker,
		PopUpModals,
		// CountryPicker,
		// CartDropDown,
		HeaderSearch,
		CartButton,
		CountrySelectorContainer,
		// MobileHeaderElements,
		AuthenticatedUserModels,
		LogoContainer
	}
}
</script>
